import { render, staticRenderFns } from "./AS_WebPolicySideNav.vue?vue&type=template&id=4e8f7dce&scoped=true&"
import script from "./AS_WebPolicySideNav.vue?vue&type=script&lang=js&"
export * from "./AS_WebPolicySideNav.vue?vue&type=script&lang=js&"
import style0 from "./AS_WebPolicySideNav.vue?vue&type=style&index=0&id=4e8f7dce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8f7dce",
  null
  
)

export default component.exports